import {
  addUpdateSalesDocuments,
  reasonCancellation,
  updateDocumentStatus,
} from 'api/mdl11'
import { validateAmountOnCommercialCredit } from 'api/mdl14'
import { BLOCK_LABELS } from 'Utils/constants'

export const generateSellOrderAction = payload => {
  return async (dispatch, getState) => {
    dispatch({ type: 'SELL_ORDER_POST_LOADING', payload: true })

    try {
      const response = await addUpdateSalesDocuments(payload)
      const { data, status } = response
      if (status === 200 && data?.Data) {
        if (data.Data !== null) {
          dispatch({ type: 'SELL_ORDER_POST_RESULT', payload: data })
        }
        dispatch({ type: 'SELL_ORDER_POST_LOADING', payload: false })
        return data
      } else {
        dispatch({
          type: 'SELL_ORDER_POST_RESULT',
          payload: { message: 'ERROR' },
        })
        dispatch({ type: 'SELL_ORDER_POST_LOADING', payload: false })
        return { message: 'ERROR' }
      }
    } catch (err) {
      console.error('Error getChannelsAction', err)
      dispatch({
        type: 'SELL_ORDER_POST_RESULT',
        payload: { message: 'ERROR' },
      })
      dispatch({ type: 'SELL_ORDER_POST_LOADING', payload: false })
      return { message: 'ERROR' }
    }
  }
}

export const generateDispatchOrderAction = payload => {
  return async (dispatch, getState) => {
    dispatch({ type: 'DISPATCH_ORDER_POST_LOADING', payload: true })

    try {
      const response = await addUpdateSalesDocuments(payload)
      const { data, status } = response
      if (status === 200 && data) {
        dispatch({ type: 'DISPATCH_ORDER_POST_RESULT', payload: data })
        dispatch({ type: 'DISPATCH_ORDER_POST_LOADING', payload: false })
        return data
      } else {
        dispatch({
          type: 'DISPATCH_ORDER_POST_RESULT',
          payload: { message: 'ERROR' },
        })
        dispatch({ type: 'DISPATCH_ORDER_POST_LOADING', payload: false })
        return { message: 'ERROR' }
      }
    } catch (err) {
      console.error('Error getChannelsAction', err)
      dispatch({
        type: 'DISPATCH_ORDER_POST_RESULT',
        payload: { message: 'ERROR' },
      })
      dispatch({ type: 'DISPATCH_ORDER_POST_LOADING', payload: false })
      return { message: 'ERROR' }
    }
  }
}

export const validateAccountStatusCommercialCredit = payload => async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await validateAmountOnCommercialCredit(payload)
    const { data } = res
    if (data) {
      if (data.Data.cuentas || data.Result.toUpperCase() === 'OK') {
        const cuenta = data.Data.cuentas[0]
        // Use bloqueado_factura if available (new API), fall back to bloqueado === '' check
        const isDisponible =
          cuenta.bloqueado_factura !== undefined
            ? cuenta.bloqueado_factura === false
            : cuenta.bloqueado === ''
        if (isDisponible) {
          return cuenta
        }
        return {
          message:
            cuenta?.etiqueta_bloqueado ||
            BLOCK_LABELS[cuenta?.bloqueado]?.message ||
            cuenta?.bloqueado,
          account: data.Data?.no_cliente,
        }
      } else {
        return { message: 'ERROR' + res.toString() }
      }
    } else {
      return { message: 'ERROR' + res.toString() }
    }
  } catch (err) {
    throw err
  }
}

export const fetchListAccountCommercialCredit = payload => async () => {
  try {
    const res = await validateAmountOnCommercialCredit(payload)
    const { data } = res
    if (data.Status?.Code === 200 || data.Result === 'Ok') {
      return data
    } else {
      return { message: 'ERROR' + res.toString() }
    }

    // return aludraApi
    //   .post(urlValidateCommercialCredit, payload)
    //   .then(res => {
    //     const { data } = res;

    //     if (data) {
    //       if (data.Status?.Code === 200 || data.Result === "Ok") {
    //         return data;
    //       } else {
    //         return { message: "ERROR" };
    //       }
    //     } else {
    //       return { message: "ERROR" };
    //     }
    //   })
    //   .catch(err => {
    //     return { message: "ERROR" };
    //   });
  } catch (err) {
    return { message: 'ERROR,' + err.message }
    // throw err;
  }
}

export const fetchReasonCancel = () => async () => {
  try {
    const response = await reasonCancellation()
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {}
}

export const updateSalesOrderStatusAction = payload => {
  return async () => {
    try {
      const response = await updateDocumentStatus(payload)
      const { data, status } = response
      if (status === 200 && data) {
        return { success: true, data }
      }
      return { success: false, message: 'ERROR' }
    } catch (err) {
      console.error('Error updateSalesOrderStatusAction', err)
      return { success: false, message: err.message }
    }
  }
}
